import { render, staticRenderFns } from "./dropdown-menu.vue?vue&type=template&id=03877b71"
import script from "./dropdown-menu.vue?vue&type=script&lang=js"
export * from "./dropdown-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports